import { StreamJsonModel, StreamSchema } from '../../domain/stream/stream/StreamDomain';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';

export type StreamActions =
  | 'CHANGE_STREAM'
  | 'CHANGE_STREAM_IS_UPDATE'
  | 'CLEAR_STREAM'
  | 'CHANGE_STREAM_SCHEMA'
  | 'CHANGE_STREAM_DEPENDENCIES'
  | 'CHANGE_STREAM_DIRTY';

export const changeStream = (payload: StreamJsonModel) =>
  ({
    type: 'CHANGE_STREAM',
    payload,
  }) as ReduxBaseAction<StreamJsonModel | null, StreamActions>;

export const changeStreamSchema = (payload: StreamSchema | null) =>
  ({
    type: 'CHANGE_STREAM_SCHEMA',
    payload,
  }) as ReduxBaseAction<StreamSchema | null, StreamActions>;

export const changeStreamIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_STREAM_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean | null, StreamActions>;

export const clearStream = () =>
  ({
    type: 'CLEAR_STREAM',
    payload: void 0,
  }) as ReduxBaseAction<any, StreamActions>;

export const changeStreamDependencies = (payload: ComponentDependency[]) =>
  ({
    type: 'CHANGE_STREAM_DEPENDENCIES',
    payload,
  }) as ReduxBaseAction<ComponentDependency[], StreamActions>;

export const changeStreamDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_STREAM_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, StreamActions>;
